import { useEffect } from "react";

import { useBreakpoint } from "../../hooks";
import { cn } from "../../lib";
import { NavHeader } from "../../molecules/nav-header";
import { Box } from "../../primitives";
import { warnHeaderConflict } from "./lib";
import type { ScreenLayoutHeaderProps } from "./types";

/**
 * ScreenLayout.Header — web.
 *
 * At mobile breakpoint (<md) renders a sticky NavHeader. At desktop (>=md)
 * returns null — the desktop chrome is owned by the route shell's
 * `AppNavbar` (DS-041).
 */
export const ScreenLayoutHeader = ({
  variant,
  title,
  subtitle,
  onBack,
  right,
  children,
  className,
  testID,
}: ScreenLayoutHeaderProps) => {
  const bp = useBreakpoint();
  const hasConvenienceProps = Boolean(title || subtitle || onBack || right);

  useEffect(() => {
    if (children && hasConvenienceProps) warnHeaderConflict();
  }, [children, hasConvenienceProps]);

  if (bp !== "sm") return null;

  if (children) {
    return <Box className={cn("sticky top-0 z-50 shrink-0", className)}>{children}</Box>;
  }

  return (
    <Box className={cn("sticky top-0 z-50 shrink-0", className)}>
      <NavHeader
        variant={variant}
        title={title}
        subtitle={subtitle}
        onBack={onBack}
        right={right}
        testID={testID}
      />
    </Box>
  );
};

ScreenLayoutHeader.displayName = "ScreenLayout.Header";
